/**
 * This is adblock detection. I was going to name it such, but it got blocked by the adblocker...
 * @author Elias Cole
 * @last_change 12.01.16
 * nbcsports.atlassian.net/browse/VODWRKFLW-2322
 */



function addStylesToPage(styles) {
  $(document.head).append(`<style>${styles}</style>`)
}

let isMobile = false

if(window.innerWidth < 700) {
  isMobile = true
}



$(() => {

  let paddingTop = isMobile ? '10px' : '100px'
  let paddingLeft = isMobile ? '10px' : '60px'
  let fontSize = isMobile ? 'large' : 'x-large'

  let styles = `
    #sherlock {
      width: 100%;
      height: 100%;
      background-color: #494949;
      opacity: 0.9 !important;
      color: #fff;
      z-index: 802;
      position: absolute;
      left: 0px;
      top: 0px;
      font-size: ${fontSize};
      text-align: -webkit-center;
      padding-top: ${paddingTop};
    }

    #sherlock-content {
      width: 90%;
      display: -webkit-box;
    }
    `

  addStylesToPage(styles)

  let message = `PLEASE TURN OFF YOUR AD BLOCKER<br>This video is unavailable if an ad blocker is running. Please disable and reload the page to start the video.`

  if(vars.language === 'es') {
    message = `Por favor, inhabilitar el bloqueo de anuncios.<br>Este video es inaccesible bajo el bloqueo de anuncios. Por favor, inhabilitar el bloqueo y recargar la página para verlo.`
  }

  // global defined in adblockDetection/showads.js
  // if an adblocker is active this file won't load
  if(window.cts_canShowAds === undefined) {
    // alert(message)
    let htmlString = `
    <span id='sherlock'>
      <span id='sherlock-content'>
        ${message}
      </span>
    </span>`
    $('body').append(htmlString)



    // this is for pausing the video on autoplay e.g. ?autoplay=true
    // $pdk.controller.addEventListener('OnMediaPlay', () => { // this doesn't work for some reason.
    $pdk.controller.addEventListener('OnMediaStart', () => {
      $pdk.controller.pause(true)
    }, ['*'])

    // backup
    // $pdk.controller.addEventListener('OnPlayerLoaded', () => {
    //   // console.log('player loaded')
    //   setTimeout(() => {
    //     $pdk.controller.pause(true)
    //   }, 2000)
    // }, ['*'])

  }



  // secondary detection method
  // adblockers adjust the height and width of nodes with 'ad' in their attributes

  // $('body').append(`<div id="bottomAd" style="font-size: 2px;">&nbsp;</div>`)

  // window.setTimeout(() => {
  //   let bottomAd = $('#bottomAd')
  //   console.log('*******************')
  //   console.log(bottomAd)
  //   console.log(bottomAd.length)
  //   console.log(bottomAd.height())
  //   console.log('*******************')
  //   if (bottomAd.length == 1) {
  //     if (bottomAd.height() == 0) {
  //       console.log('adblocker active')
  //     } else {
  //       console.log('no adblocker detected')
  //     }
  //   }
  // }, 200)

})

























